import React from "react";
import Sidebar from "../../../components/layout/Sidebar";
import { useNavigate, useParams } from "react-router-dom";

export default function CreateActivity() {
  const navigate = useNavigate();
  const { processId } = useParams();

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <main className="flex-1 bg-softWhite flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-8 py-4 border-b bg-white shadow-sm">
          <h2 className="text-2xl font-semibold text-darkBrown">
            Crear / Editar Actividad (Proceso #{processId})
          </h2>
          <button
            onClick={() => navigate(`/processes/${processId}/activities`)}
            className="bg-gray-400 hover:bg-gray-500 text-white px-4 py-2 rounded-md transition"
          >
            ← Volver
          </button>
        </div>

        {/* Formulario */}
        <div className="p-8">
          <form className="bg-white shadow-md rounded-xl p-6 space-y-4 max-w-lg">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Código de Actividad
              </label>
              <input
                type="text"
                className="w-full border-gray-300 rounded-md p-2 focus:ring-brickRed focus:border-brickRed"
                placeholder="Ej. A001"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nombre de la Actividad
              </label>
              <input
                type="text"
                className="w-full border-gray-300 rounded-md p-2 focus:ring-brickRed focus:border-brickRed"
                placeholder="Ej. Iniciar revisión general"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Tipo de Comportamiento
              </label>
              <select className="w-full border-gray-300 rounded-md p-2 focus:ring-brickRed focus:border-brickRed">
                <option value="">Seleccione una opción</option>
                <option value="DATE_INPUT">Fecha / Tiempo</option>
                <option value="QUANTITY_INPUT">Cantidad</option>
                <option value="CHECK">Confirmación / Check</option>
              </select>
            </div>

            <div className="flex items-center">
              <input type="checkbox" id="repeatable" className="mr-2" />
              <label htmlFor="repeatable" className="text-sm text-gray-700">
                Es repetible
              </label>
            </div>

            <div className="flex justify-end space-x-2">
              <button
                type="button"
                className="bg-gray-300 hover:bg-gray-400 text-darkBrown px-4 py-2 rounded-md transition"
                onClick={() => navigate(`/processes/${processId}/activities`)}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="bg-brickRed hover:bg-brickRedHover text-softWhite px-4 py-2 rounded-md transition"
              >
                Guardar
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
}
